import * as React from "react";
import { SVGProps } from "react";

/**
 * Four rings: a set of alternatives to pick one from.
 *
 * Sized for a band heading, where the busier "restaurant choice" glyph loses
 * its arrows and the segmented ring reads as a loading spinner.
 *
 * The viewBox is padded rather than the element shrunk. The four rings reach
 * the edge of a plain 24 box where the allergen glyphs inset their circle, so
 * at an equal declared size this one read noticeably larger. Padding to 28
 * insets the artwork to the same proportion, which lets every band icon render
 * at one size. The 2.8 stroke lands on the same 2px as those rings at 20.
 */
export const ChoicesIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="-2 -2 28 28"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={2.8}
    {...props}
  >
    <path d="M0.75 5.255a4.5 4.5 0 1 0 9 0 4.5 4.5 0 1 0 -9 0Z" />
    <path d="M0.75 18.755a4.5 4.5 0 1 0 9 0 4.5 4.5 0 1 0 -9 0Z" />
    <path d="M14.25 5.255a4.5 4.5 0 1 0 9 0 4.5 4.5 0 1 0 -9 0Z" />
    <path d="M14.25 18.755a4.5 4.5 0 1 0 9 0 4.5 4.5 0 1 0 -9 0Z" />
  </svg>
);
